import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import manageRolesRouter from "./manageRolesRouter";

function ManageRolesTab(props) {

  return (
    <TabTemplate 
      router={manageRolesRouter}
      passData={props.passData}
    />
  )

}

export default ManageRolesTab;